import HexController from 'controllers/hex_controller'

export default class extends HexController {
  static targets = ['button', 'icon', 'text'];
  static values = {
    url: String
  }

  connect() {
    this.element.addEventListener('click', this.resetAiUsage.bind(this))
  }

  disconnect() {
    this.element.removeEventListener('click', this.resetAiUsage.bind(this))
  }

  resetAiUsage() {
    if (this.element.classList.contains('disabled')) {
      return
    }
    if (!confirm('Are you sure you want to reset the AI usage for this user?')) {
      return
    }

    this.element.classList.add('disabled')
    this.iconTarget.classList.add('spin')

    fetch(this.urlValue, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        authenticity_token: document.head.querySelector('meta[name="csrf-token"]').content // From document head
      })
    })
      .then(response => {
        this.element.classList.remove('disabled')
        this.iconTarget.classList.remove('spin')

        if (response.ok && response.status >= 200 && response.status < 300) {
          this.textTarget.textContent = '0';
          this.textTarget.dataset.controller = '';
          this.buttonTarget.classList.add('hidden');
        } else {
          alert('Failed to reset AI usage, please try again.');
        }
      })
  }
}